import {
  ArrowRightIcon,
  GoogleLogoIcon,
  LockKeyIcon,
} from "@phosphor-icons/react";
import { Button } from "@cloudflare/kumo/components/button";
import BrandMark from "../components/common/BrandMark";
import AppAlert from "../components/common/AppAlert";
import { useAuth } from "../hooks/useAuth";
import { getPortalLoginUrl } from "../features/sso/ssoClient";

export default function LoginPage() {
  const {
    error,
    unauthorizedEmail,
    loading,
    enterDemo,
    demoModeAvailable,
    isFirebaseConfigured,
  } = useAuth();

  return (
    <main className="grid min-h-screen grid-cols-[minmax(420px,1.2fr)_minmax(380px,.8fr)] max-md:block">
      <section
        className="relative flex min-h-screen flex-col justify-between overflow-hidden bg-ink p-[clamp(40px,6vw,84px)] text-white max-md:min-h-[42vh] max-md:p-7"
        aria-label="PreNexus"
      >
        <BrandMark />
        <div className="relative z-10 my-20 max-w-[690px] max-md:my-16 max-md:mb-8">
          <span className="mb-5 block font-display text-xs font-bold tracking-[0.16em] text-yellow uppercase">
            Quality at ease
          </span>
          <h1 className="m-0 max-w-[760px] font-display text-[clamp(3rem,6vw,6.3rem)] font-extrabold leading-[0.96] tracking-[-0.055em] max-md:text-[2.8rem]">
            <span className="block">Collaboration,</span>
            <span className="block">One platform,</span>
            <span className="block">Every decision.</span>
          </h1>
          <p className="mt-6 max-w-[760px] font-display text-[clamp(1.1rem,2.15vw,2rem)] font-bold leading-[1.08] tracking-[-0.025em] text-white max-md:text-lg">
            Bring artwork, color, approvals, and production together.
          </p>
        </div>
        <div
          className="grid w-[min(430px,80%)] grid-cols-[auto_1fr_auto_1fr_auto_1fr_auto] items-center gap-2.5 font-display text-[0.64rem] font-bold text-[#aaa49c] max-md:hidden [&_i]:h-px [&_i]:bg-[#494542]"
          aria-hidden="true"
        >
          <span>C</span>
          <i />
          <span>M</span>
          <i />
          <span>Y</span>
          <i />
          <span>K</span>
        </div>
      </section>

      <section className="grid min-h-screen place-items-center bg-paper-bright p-10 max-md:min-h-[58vh] max-md:px-5 max-md:py-10">
        <div className="flex w-[min(100%,430px)] flex-col gap-3.5">
          <div className="mb-5 grid size-12 place-items-center rounded-full border border-line-dark bg-yellow shadow-[7px_7px_0_#191716]">
            <LockKeyIcon size={22} weight="bold" />
          </div>
          <span className="font-display text-xs font-bold tracking-[0.16em] text-muted uppercase">
            Area internal
          </span>
          <h2 className="m-0 font-display text-[clamp(2rem,4vw,3.3rem)] font-bold leading-none tracking-[-0.045em]">
            Masuk ke PreNexus
          </h2>
          <p className="my-2 leading-relaxed text-muted">
            Continue through the LPHTM portal. Direct workspace access is disabled.
          </p>

          {unauthorizedEmail ? (
            <AppAlert
              variant="error"
              title="Akses belum diberikan"
              description={`${unauthorizedEmail} tidak terdaftar atau sedang nonaktif.`}
            />
          ) : null}
          {error ? (
            <AppAlert variant="error" title="Login gagal" description={error} />
          ) : null}
          {!isFirebaseConfigured ? (
            <AppAlert
              variant="secondary"
              title="Konfigurasi Firebase diperlukan"
              description={
                <span>
                  Salin <code>.env.example</code> menjadi{" "}
                  <code>.env.local</code> lalu isi Web App config.
                </span>
              }
            />
          ) : null}

          <Button
            variant="primary"
            size="lg"
            icon={GoogleLogoIcon}
            loading={loading}
            disabled={!isFirebaseConfigured}
            onClick={() => window.location.assign(getPortalLoginUrl())}
            className="mt-2! w-full! justify-center!"
          >
            Lanjutkan melalui portal LPHTM
          </Button>

          {demoModeAvailable ? (
            <Button
              variant="outline"
              size="lg"
              icon={ArrowRightIcon}
              onClick={enterDemo}
            >
              Buka mode demo lokal
            </Button>
          ) : null}
        </div>
      </section>
    </main>
  );
}
